// Build identity attached to every PostHog event (super properties), so client
// errors and funnel drops can be tied to a deploy. The SHA is baked in at build
// time: the Dockerfile maps Coolify's SOURCE_COMMIT build-arg to
// EXPO_PUBLIC_APP_BUILD. Pure module (no RN imports) so it is unit-testable.

export const APP_BUILD_FALLBACK = 'dev';

export type AppSurface = 'app' | 'landing';

export type BuildSuperProperties = {
  app_build: string;
  app_surface: AppSurface;
};

/** Short (7-char) commit SHA, or the trimmed raw value, or "dev" when absent. */
export function resolveAppBuild(raw?: string | null): string {
  const value = (raw ?? '').trim();
  if (!value) return APP_BUILD_FALLBACK;
  if (/^[0-9a-f]{7,40}$/i.test(value)) return value.slice(0, 7).toLowerCase();
  return value.slice(0, 40);
}

export function buildSuperProperties(
  surface: AppSurface,
  raw?: string | null,
): BuildSuperProperties {
  return { app_build: resolveAppBuild(raw), app_surface: surface };
}

// Static property access so Expo inlines the value at build time.
export const APP_BUILD_PROPERTIES = buildSuperProperties('app', process.env.EXPO_PUBLIC_APP_BUILD);
